import styled, { css } from "styled-components";
import { Form } from "antd";
import {
  BASE_COLORS,
  FONT_FAMILY,
  FONT_SIZE,
  FONT_SIZE_PX,
  FONT_WEIGHT,
  media,
} from "config/theme/constants";

interface FormItemProps {
  $isSuccess?: boolean;
  $successText?: string;
}

export const BaseFormItem = styled(Form.Item)<FormItemProps>`
  .ant-form-item-label > label {
    color: ${BASE_COLORS.black};
    font-size: ${FONT_SIZE_PX.xs};
    opacity: 1;
    min-width: 125px;
  }

  .ant-input-group-addon:first-of-type {
    font-weight: ${FONT_WEIGHT.semibold};
    width: 5rem;

    color: var(--primary-color);

    .anticon,
    svg {
      font-size: ${FONT_SIZE.xl};
    }

    @media only screen and ${media.md} {
      width: 5.5rem;
      font-size: ${FONT_SIZE.lg};
    }

    @media only screen and ${media.xl} {
      font-size: ${FONT_SIZE.xxl};
    }
  }

  .ant-input-suffix .ant-btn {
    padding: 0;
    width: unset;
    height: unset;
    line-height: 1;
  }

  .ant-form-item-explain-error {
    display: flex;
    margin: 0.5rem 0;
    line-height: 1;
    font-weight: ${FONT_WEIGHT.normal};
    font-size: ${FONT_SIZE_PX.xs} !important;
    font-family: ${FONT_FAMILY.main};
    letter-spacing: 0px;
    color: ${BASE_COLORS.sunsetOrange};
    opacity: 1;

    &:not(:first-of-type) {
      display: none;
    }
  }

  ${(props) =>
    props.$isSuccess &&
    css`
      .ant-input {
        &,
        &:hover {
          border-color: var(--success-color);
        }
      }

      .ant-form-item-control-input {
        display: block;

        &::after {
          content: "✓ ${props.$successText}";
          color: var(--success-color);
        }
      }
    `}

  &.ant-form-item-has-feedback .ant-form-item-children-icon {
    display: none;
  }

  .ant-picker-suffix {
    font-size: ${FONT_SIZE.md};
  }

  .ant-select-arrow {
    font-size: ${FONT_SIZE.md};
    width: unset;
    height: unset;
    top: 50%;
  }

  &.ant-form-item-has-error .ant-input,
  &.ant-form-item-has-error .ant-input-affix-wrapper,
  &.ant-form-item-has-error .ant-input:hover,
  &.ant-form-item-has-error .ant-input-affix-wrapper:hover {
    border-color: #ff4d4f !important;
  }

  &.ant-form-item-has-success.ant-form-item-has-feedback .ant-input,
  &.ant-form-item-has-success.ant-form-item-has-feedback
    .ant-input-affix-wrapper,
  &.ant-form-item-has-success.ant-form-item-has-feedback .ant-input:hover,
  &.ant-form-item-has-success.ant-form-item-has-feedback
    .ant-input-affix-wrapper:hover {
    border-color: var(--success-color);
  }
`;
